<template>
    <v-sheet>
        <v-row class="ma-n2 ma-lg-n4">
            <template v-for="item in items">
                <v-col class="pa-2 pa-lg-4" cols="6" v-bind="{ lg }" :key="item.value">
                    <v-responsive :aspect-ratio="$vuetify.breakpoint.mobile ? 3 / 2 : 3 / 1" style="overflow:visible">
                        <v-card
                            elevation="0"
                            style="overflow:visible;pointer-events:none"
                            class="fill-height"
                            v-bind="{
                                disabled: item.disabled || loading,
                                to: `/exchange/${item.value.toLowerCase()}`,
                            }"
                            @click.capture.stop.prevent="go(item)"
                        >
                            <v-card
                                v-bind="{
                                    elevation: item.active ? 0 : undefined,
                                    outlined: item.active,
                                    class: {
                                        'exchange-codes__card': true,
                                        'exchange-codes__card--active': item.active,
                                        'fill-height': true,
                                    },
                                }"
                                rounded
                            >
                                <v-card-text class="fill-height d-flex justify-center align-center px-4 py-0">
                                    <v-img
                                        v-bind="{
                                            ...item.image,
                                            contain: true,
                                        }"
                                    />
                                </v-card-text>
                            </v-card>
                        </v-card>
                    </v-responsive>
                </v-col>
            </template>
        </v-row>
    </v-sheet>
</template>
<script>
import { USER_EXCHANGE_CODES } from "@/assets/lib";
export default {
    props: {
        value: {
            /** @type {import('vue').PropType<import('@/assets/lib').UserExchange[]>} */
            type: Array,
            default: () => [],
        },

        mode: {
            /** @type {import('vue').PropType<'form'|'view'>} */
            type: String,
            default: "form",
        },

        code: {
            /** @type {import('vue').PropType<keyof USER_EXCHANGE_CODES>} */
            type: String,
            default: USER_EXCHANGE_CODES.AUCTION.value.toLowerCase(),
        },

        loading: {
            /** @type {import('vue').PropType<boolean>} */
            type: Boolean,
            default: false,
        },
    },
    computed: {
        template() {
            return () => import(`@/templates/${this.$theme.pages.gshop}`);
        },
        items() {
            return [
                {
                    ...USER_EXCHANGE_CODES.AUCTION,
                    image: { src: "/images/exchange/vendors/auction.svg" },
                },
                {
                    ...USER_EXCHANGE_CODES.GMARKET,
                    image: { src: "/images/exchange/vendors/gmarket.svg" },
                },
                {
                    ...USER_EXCHANGE_CODES.SSG_COM,
                    image: { src: "/images/exchange/vendors/ssg_com.svg" },
                    // disabled: true,
                },
                {
                    ...USER_EXCHANGE_CODES.LOTTEON,
                    image: { src: "/images/exchange/vendors/lotteon.svg" },
                    // disabled: true,
                },
                // {
                //     ...USER_EXCHANGE_CODES.TESTCODE,
                //     image: { src: "/images/logo.png" },
                // },
            ].map((item) => ({
                ...item,
                active: item.value.toLowerCase() == this.code,
            }));
        },
        lg() {
            let lg = 12 % this.items.length;
            if (3 <= lg) return 12 / this.items.length;
            return 3;
        },
    },
    methods: {
        go(code) {
            // switch (this.mode) {
            //     case "form": {
            //         let hasSomeNumbers = this.value.some((item) => !!item.prev);
            //         if (hasSomeNumbers) {
            //             let go = confirm("입력하신 교환권 번호가 있습니다. 상품권 종류 변경 시 입력하신 내용이 초기화됩니다.\n\n계속하시겠습니까?");
            //             if (!go) return;
            //         }
            //         break;
            //     }
            //     case "view": {
            //         let go = confirm("교환하신 내역이 있습니다. 상품권 종류 변경 시 바로 충전하기 및 선물하기 기능을 이용하실 수 없습니다.\n\n계속하시겠습니까?");
            //         if (!go) return;
            //         break;
            //     }
            // }
            // this.$router.push(`/exchange/${code.value.toLowerCase()}`);
        },
    },
};
</script>

<style lang="scss" scoped>
.exchange-codes__card {
    &--active {
        border: 1px solid var(--v-primary-base) !important;
    }
}
</style>
